import React, { Component, useEffect, useState } from 'react'
import '../styles/Reports.css'
import DropdownWidget from '../widgets/DropdownWidget'
import OrgFooter from '../widgets/OrgFooter'
import DatePicker from '../widgets/DatePicker'
import APIGenericRequest from '../api/APIGenericRequest'
import APIReportRequest from '../api/APIReportRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'
import ActivityIndicator from '../widgets/ActivityIndicator'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'
import AlertMessage from '../widgets/AlertMessage'

class ReportFarmerML extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: localStorage.getItem("siteId"),
			disabled: props.disabled
		}
		this.getAllTrainingsAttendedByFarmerIDAndDateRAnge = this.getAllTrainingsAttendedByFarmerIDAndDateRAnge.bind(this)
		this.getAllClusterMembershipsByFarmerID = this.getAllClusterMembershipsByFarmerID.bind(this)
		this.getAllIncomeByFarmerIDAndDateRAnge = this.getAllIncomeByFarmerIDAndDateRAnge.bind(this)
		this.getAllFinancialTransactionsByFarmerIDAndDateRAnge = this.getAllFinancialTransactionsByFarmerIDAndDateRAnge.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.getServerDateTime = this.getServerDateTime.bind(this)
	}

	componentWillMount() {
		this.getAllTrainingsAttendedByFarmerIDAndDateRAnge()
	}

	getAllTrainingsAttendedByFarmerIDAndDateRAnge(farmerId, start, end) {
		const ext = APIReportRequest.getAllTrainingsAttendedByFarmerIDAndDateRAnge(this.state.accessToken, farmerId, start, end)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getAllClusterMembershipsByFarmerID(farmerId) {
		const ext = APIReportRequest.getAllClusterMembershipsByFarmerID(this.state.accessToken, farmerId)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			console.log('getAllClusterMembershipsByFarmerID', response)
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getAllIncomeByFarmerIDAndDateRAnge(farmerId, start, end) {
		const ext = APIReportRequest.getAllIncomeByFarmerIDAndDateRAnge(this.state.accessToken, farmerId, start, end)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getAllFinancialTransactionsByFarmerIDAndDateRAnge(farmerId, start, end) {
		const ext = APIReportRequest.getAllFinancialTransactionsByFarmerIDAndDateRAnge(this.state.accessToken, farmerId, start, end)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	handleFooterEvent(e) {
		if(this.state.data == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "No data for export. Please generate report."
			})
			return;
		}
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state.data['region'] = user.region
		this.state.data['siteName'] = localStorage.getItem("siteName")
		const farmerName = `${this.state.data.farmer.first_name}_${this.state.data.farmer.last_name}`.toUpperCase()
		const dateObj = new Date();
		const month = dateObj.getMonth() + 1;
		const date = month + "-" + dateObj.getDate() + "-" + dateObj.getFullYear();
		switch(this.state.typeId) {
			case 1:
				var filename = "TrainingsAttendedReport-" + farmerName + "-" + date;
				break
			case 2:
				filename = "ClusterMembershipReport-" + farmerName + "-" + date;
				break
			case 3:
				filename = "IncomeReport-" + farmerName + "-" + date;
				break
			case 4:
				filename = "FinancialTransactionsReport-" + farmerName + "-" + date;
		}
		// exportToCSV(this.state.data, filename, this.state.typeId, this.state.period)
		this.getServerDateTime(filename)
	}

	getServerDateTime(filename) {
		const apiReq = APIGenericRequest.getServerDateTime(this.state.accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const dateTime = new Date(response.results.date_time)
			exportToCSV(
				this.state.data,
				filename,
				this.state.typeId,
				this.state.period,
				dateTime
			)
		})
	}

	render() {
		const view = <div id="report-farmer">
			<div className="report-details-left"><FilterReport siteId={this.state.siteId} generate={(v) => {
				console.log(v)
				switch(parseInt(v.typeId)) {
					case 1:
						this.getAllTrainingsAttendedByFarmerIDAndDateRAnge(v.farmerId, v.startDate, v.endDate)
						break
					case 2:
						this.getAllClusterMembershipsByFarmerID(v.farmerId)
						break
					case 3:
						this.getAllIncomeByFarmerIDAndDateRAnge(v.farmerId, v.startDate, v.endDate)
						break
					case 4:
						this.getAllFinancialTransactionsByFarmerIDAndDateRAnge(v.farmerId, v.startDate, v.endDate)
				}
				this.setState({
					typeId: parseInt(v.typeId),
					period: {from: v.startDate, to: v.endDate},
					data: null
				})
			}} /></div>
			<div className="report-details-right">
				<ReportContent data={this.state.data} typeId={this.state.typeId} />
				<div className='reports-footer'>
					<OrgFooter eventHandler={this.handleFooterEvent}
						showSubmit={false}
						showExport={true} />
				</div>
			</div>
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class FilterReport extends Component
{
	constructor(props) {
		super(props)
		const date = new Date()
		const m = date.getMonth()+1
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: props.siteId,
			reportType: "COLLECTIVE MARKETING",
			reportSubType: "CLUSTER MEMBERS",
			types: [
				{id: 1, name: "TRAININGS ATTENDED"},
				{id: 2, name: "CLUSTER MEMBERSHIP"},
				{id: 3, name: "INCOME"},
				{id: 4, name: "FINANCIAL TRANSACTION"},
			],
			type: '-- SELECT --',
			endDate: date.getFullYear() + '-' + m + '-' + date.getDate()
		}
		this.getAllFarmersBySiteId = this.getAllFarmersBySiteId.bind(this)
	}

	componentWillMount() {
		this.getAllFarmersBySiteId()
	}

	getAllFarmersBySiteId() {
		// NOTE: getAllFarmersBySiteId duplicate farmer data
		const apiReq = APIFarmerRequest.getAllFarmersBySiteId(this.state.accessToken, this.state.siteId)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			// NOTE: temp solution to duplicate farmer data
			const tempFarmers = {}
			const farmerList = {}
			response.results.rows.map((item, i) => {
				let fullName = `${item.first_name}`
				if(item.middle_name) {
					fullName += ` ${item.middle_name}`
				}
				fullName += ` ${item.last_name}`
				if(item.extension_name) {
					fullName += ` ${item.extension_name}`
				}
				tempFarmers[item.registration_no] = {id: item.registration_no, name: fullName}
				farmerList[item.registration_no] = item.farmer_id
			})
			const farmers = Object.values(tempFarmers)
			this.setState({farmers: farmers, farmerList: farmerList})
		})
	}

	render() {
		const view = <div className="filter-report">
			<div style={{'margin-bottom': '5px'}}>Farmer Name/Reg ID</div>
			<InputTextFilterWidget list={this.state.farmers} showId={true} onChange={(v) => {
				const st = {nameOnChanged: v}
				if(v === '') {
					st['regId'] = null
				}
				this.setState(st)
			}}
			onItemSelected={(id, val) => {
				this.setState({regId: id})
				if(id != null) {
					this.setState({showNameMSG: false, nameOnChanged: val})
				}

			}} placeholder={this.state.farmer} />
			{this.state.showNameMSG && <div style={{color: '#c96f6f'}}>* Enter farmer name</div>}
			<br />
			<div>Type of Report:</div>
			<DropdownWidget list={this.state.types} placeholder={this.state.type} onItemSelected={(id, val) => {
				let disable = false
				if(id == 2) {
					disable = true
				}
				this.setState({
					typeId: id,
					disableDate: disable,
					showTypeMSG: false
				})
			}} />
			{this.state.showTypeMSG && <div style={{color: '#c96f6f'}}>* Select type of report</div>}
			{/* {(this.state.typeId != 2 || this.state.typeId == null ) && <div> */}
			<div>
				<br />
				<div style={{'margin-bottom': '5px'}}>From Date:</div>
				<DatePicker onChange={(value) => {
					let showDateMSG = true
					if(this.state.endDate != null) {
						showDateMSG = false
					}
					this.setState({startDate: value, showDateMSG: showDateMSG})
				}} value={this.state.startDate} max={this.state.endDate} disabled={this.state.disableDate} />
				<br />
				<div style={{'margin-bottom': '5px'}}>To Date:</div>
				<DatePicker onChange={(value) => {
					let showDateMSG = true
					if(this.state.startDate != null) {
						showDateMSG = false
					}
					this.setState({endDate: value, showDateMSG: showDateMSG})
				}} value={this.state.endDate} min={this.state.startDate} disabled={this.state.disableDate} />
				{this.state.showDateMSG && <div style={{color: '#c96f6f', 'margin-top': '2px'}}>* Select date range</div>}
			</div>
			<br />
			<button className="green-two" onClick={(k, v) => {
				if(this.state.regId == null || this.state.nameOnChanged == '') {
					this.setState({showNameMSG: true})
				}
				else {
					this.setState({showNameMSG: false})
				}
				if(this.state.typeId == null) {
					this.setState({showTypeMSG: true})
				}
				else {
					this.setState({showTypeMSG: false})
				}
				if((this.state.startDate == null || this.state.endDate == null) && this.state.typeId != 2) {
					this.setState({showDateMSG: true})
				}
				else {
					this.setState({showDateMSG: false})
				}
				const filter = {
					farmerId: this.state.farmerList[this.state.regId],
					typeId: this.state.typeId,
					startDate: this.state.startDate,
					endDate: this.state.endDate
				}
				this.props.generate(filter)
			}}>GENERATE</button>
			<button className="green-two" onClick={(k, v) => {
				const filter = {
					typeId: null,
				}
				this.props.generate(filter)
				this.setState({
					farmerId: null,
					regId: null,
					typeId: null,
					type: '-- SELECT --',
					farmer: '',
					startDate: null,
					endDate: null,
					showCropMSG: false,
					showDateMSG: false,
					showTypeMSG: false,
				})
			}}>CLEAR</button>

		</div>
		return(view)
	}
}

class ReportContent extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			region: user.region,
			siteName: localStorage.getItem("siteName"),
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data && this.props.data != null) {
			switch(parseInt(this.props.typeId)) {
				case 1:
					var trainings = []
					this.props.data.trainingsAttended.map((item, i) => {
						trainings.push(<Training data={item} key={Math.random()} />)
					})
					break
				case 2:
					var clusters = []
					this.props.data.clusters.map((item, i) => {
						console.log('clusters', item)
						clusters.push(<Cluster data={item} key={Math.random()} />)
					})
					break
				case 3:
					var income = []
					var totalGrossIncome = 0
					var totalNetIncome = 0
					this.props.data.income.map((item, i) => {
						totalNetIncome += item.net_income
						totalGrossIncome += item.gross_income
						income.push(<Income data={item} key={Math.random()} />)
					})
					break
				case 4:
					var transactions = []
					this.props.data.financialTransactions.map((item, i) => {
						transactions.push(<Transactions data={item} key={Math.random()} />)
					})
			}
			// let ext = ''
			// if(this.props.data.farmer.extension_name) {
			// 	ext = this.props.data.farmer.extension_name
			// }
			// const farmerName = `${this.props.data.farmer.first_name} ${this.props.data.farmer.middle_name} ${this.props.data.farmer.last_name} ${ext}`
			const farmerName = formatName(this.props.data.farmer.first_name, this.props.data.farmer.middle_name, this.props.data.farmer.last_name, this.props.data.farmer.extension_name)

			this.setState({
				province: this.props.data.farmer.province,
				city: this.props.data.farmer.city,
				barangay: this.props.data.farmer.barangay,
				farmerName: farmerName.toUpperCase(),
				registrationNo: this.props.data.farmer.registration_no,
				address: this.props.data.farmer.address,
				trainings: trainings,
				clusters: clusters,
				income: income,
				transactions: transactions,
				totalGrossIncome: formatCurrency(totalGrossIncome),
				totalNetIncome: formatCurrency(totalNetIncome)
			})
		}
	}

	render() {
		const view = <div id="report-content-farmer">
			{this.props.data == null && <div className="rcf-content"></div>}
			{this.props.data != null && <div className="rcf-content">
				<div>
				<table className="rcf-table-one">
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<tr>
						<th>REGION</th>
						<th>PROVINCE</th>
						<th>SITE NAME</th>
					</tr>
					<tr>
						<td><div>{this.state.region}</div></td>
						<td><div>{this.state.province}</div></td>
						<td><div>{this.state.siteName}</div></td>
					</tr>
				</table>
				<table className="rcf-table-two">
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<tr>
						<th>FARMER NAME</th>
						<th>REGISTRATION NUMBER</th>
						<th>ADDRESS</th>
					</tr>
					<tr>
						<td><div>{this.state.farmerName}</div></td>
						<td><div>{this.state.registrationNo}</div></td>
						<td><div>{this.state.barangay}, {this.state.city}</div></td>
					</tr>
				</table>
				{this.props.typeId == 1 && <TrainingsAttended trainings={this.state.trainings}/>}
				{this.props.typeId == 2 && <ClusterMembership clusters={this.state.clusters} />}
				{this.props.typeId == 3 && <FarmerIncome income={this.state.income}
					tgi={this.state.totalGrossIncome} tni={this.state.totalNetIncome} />}
				{this.props.typeId == 4 && <FinancialTransactions transactions={this.state.transactions} />}
			</div>
			</div>}
		</div>
		return(view)
	}
}

const TrainingsAttended = (props) => {
	return(<table className="rcf-table-three">
	<col style={{width: 'auto'}} />
	<col style={{width: 'auto'}} />
	<col style={{width: 'auto'}} />
	<tr>
		<th colspan='5'>TRAININGS ATTENDED</th>
	</tr>
	<tr>
		<th>DATE</th>
		<th>NO. OF DAYS<br/>ATTENDED</th>
		<th>ACTIVITY NAME</th>
		<th>VENUE</th>
		<th>REGION, PROVINCE, MUNICIPALITY, BARANGAY</th>
	</tr>
	{props.trainings}
</table>)
}

const Training = (props) => {
	const date = formatDate(props.data.start_date) + ' - ' + formatDate(props.data.end_date)
	return(<tr>
		<td><div>{date}</div></td>
		<td><div>{props.data.no_of_days}</div></td>
		<td><div>{props.data.training_module}</div></td>
		<td><div>{props.data.venue.toUpperCase()}</div></td>
		<td><div>{props.data.region}, {props.data.province}, {props.data.city}, {props.data.barangay}</div></td>
	</tr>)
}

const ClusterMembership = (props) => {
	return( <table className="rcf-table-three">
	<col style={{width: 'auto'}} />
	<tr>
		<th>CLUSTERS</th>
		<th>FOCUS CROP</th>
	</tr>
	{props.clusters}
</table>)
}

const Cluster = (props) => {
	return(<tr>
		<td><div>{props.data.cluster_name.toUpperCase()}</div></td>
		<td><div>{props.data.focus_crop}</div></td>
	</tr>)
}

const FarmerIncome = (props) => {
	return(<table className="rcf-table-three">
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<tr>
			<th colspan='5'>INCOME</th>
		</tr>
		<tr>
			<th style={{'background-color': '#e6f0c4'}}>TOTAL</th>
			<th style={{'background-color': '#e6f0c4'}}></th>
			<th style={{'background-color': '#e6f0c4'}}></th>
			<th style={{'background-color': '#e6f0c4'}}>Php {props.tgi}</th>
			<th style={{'background-color': '#e6f0c4'}}>Php {props.tni}</th>
		</tr>
		<tr>
			<th>DELIVERY DATE</th>
			<th>CROP</th>
			<th>SUPPLY DELIVERED</th>
			<th>GROSS INCOME (Php)</th>
			<th>NET INCOME (Php)</th>
		</tr>
		{props.income}
	</table>)
}
const Income = (props) => {
	const date = formatDate(props.data.delivery_date)
	return(<tr>
		<td><div>{date}</div></td>
		<td><div>{props.data.crop}</div></td>
		<td><div>{formatCurrency(props.data.supply_delivered)}</div></td>
		<td><div>{formatCurrency(props.data.gross_income)}</div></td>
		<td><div>{formatCurrency(props.data.net_income)}</div></td>
	</tr>)
}

const FinancialTransactions = (props) => {
	return(<table className="rcf-table-three">
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<col style={{width: 'auto'}} />
		<tr>
			<th colspan='7'>FINANCIAL TRANSACTINOS</th>
		</tr>
		<tr>
			<th>DATE OF RELEASE</th>
			<th>DUE DATE</th>
			<th>AMOUNT AVAILED (Php)</th>
			<th>LOAN PROVIDER</th>
			<th>LOAN SOURCE</th>
			<th>LOAN TYPE</th>
			<th>STATUS OF LOAN</th>
		</tr>
		{props.transactions}
	</table>)
}

const Transactions = (props) => {
	const dateOfRelease = formatDate(props.data.release_date)
	const dueDate = formatDate(props.data.due_date)
	return(<tr>
		<td><div>{dateOfRelease}</div></td>
		<td><div>{dueDate}</div></td>
		<td><div>{formatCurrency(props.data.amount_availed)}</div></td>
		<td><div>{props.data.loan_provider_name.toUpperCase()}</div></td>
		<td><div>{props.data.loan_source_name.toUpperCase()}</div></td>
		<td><div>{props.data.loan_type_name}</div></td>
		<td><div>{props.data.loan_status_name}</div></td>
	</tr>)
}

const formatDate = (v) => {
	const dt = new Date(v)
	const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
	const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
	const dFormat = `${m}/${d}/${dt.getFullYear()}`
	return dFormat
}

const formatCurrency = (value) => {
	if(value == null) {
		return
	}
	const val = value.toString()
	const v = val.replace(/,/g, "")
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

const formatName = (fn, mn, ln, en) => {
	let mi = ''
	if(mn) {
		mi = ' ' + mn.charAt(0).toUpperCase() + '.'
	}
	let ext = ''
	if(en) {
		ext = ' ' + en.toUpperCase()
	}
	const name = `${fn.toUpperCase()}${mi} ${ln.toUpperCase()} ${ext} `
	return name
}

const exportToCSV = (csvData, filename, typeId, period, dateTime) => {
	const dateObj = new Date()
	const month = dateObj.getMonth() + 1
	const dt = dateObj.getDate() - 1
	const date = month + "/" + dt + "/" + dateObj.getFullYear()
	const data = []
	let ext = ''
	if(csvData.farmer.extension_name) {
		ext = csvData.farmer.extension_name
	}
	const fn = `${csvData.farmer.first_name} ${csvData.farmer.middle_name} ${csvData.farmer.last_name} ${ext}`
	const farmerName = fn.toUpperCase()
	switch(typeId) {
		case 1:
			data.push(["TRAININGS%20ATTENDED%20REPORT"])
			data.push(["Period%20Covered:",`${formatDate(period.from)}%20to%20${formatDate(period.to)}`])
			break
		case 2:
			data.push(["CLUSTER%20MEMBERSHIP%20REPORT"])
			break
		case 3:
			data.push(["INCOME%20REPORT"])
			data.push(["Period%20Covered:",`${formatDate(period.from)}%20to%20${formatDate(period.to)}`])
			break
		case 4:
			data.push(["FINANCIAL%20TRANSACTION%20REPORT"])
			data.push(["Period%20Covered:",`${formatDate(period.from)}%20to%20${formatDate(period.to)}`])
		}
	data.push([])
	data.push(["REGION","PROVINCE","SITE%20NAME"])
	data.push([csvData.region.replace(/\s+/g, '%20'),csvData.farmer.province.replace(/\s+/g, '%20'),csvData.siteName.replace(/\s+/g, '%20')])
	data.push([])
	data.push(["FARMER%20NAME","REGISTRATION%20NUMBER","ADDRESS"])
	data.push([farmerName.replace(/\s+/g, '%20'),csvData.farmer.registration_no.replace(/\s+/g, '%20'),`${csvData.farmer.barangay.replace(/\s+/g, '%20')}%20${csvData.farmer.city.replace(/\s+/g, '%20')}`])
	data.push([])
	switch(typeId) {
		case 1:
			data.push(["TRAININGS%20ATTENDED"])
			data.push(["DATE", "ACTIVITY%20NAME","VENUE","REGION,%20PROVINCE,%20MUNICIPALITY,%20BARANGAY"])
			csvData.trainingsAttended.map((item, i) => {
				const date = formatDate(item.start_date) + ' - ' + formatDate(item.end_date)
				const venue = item.venue.toUpperCase()
				data.push([date.replace(/\s+/g, '%20'),item.training_module.replace(/\s+/g, '%20'),venue.replace(/\s+/g, '%20'),item.region.replace(/\s+/g, '%20'),item.province.replace(/\s+/g, '%20'),item.city.replace(/\s+/g, '%20'),item.barangay.replace(/\s+/g, '%20')])
			})
			break
		case 2:
			data.push(["CLUSTERS", 'FOCUS CROP'])
			csvData.clusters.map((item, i) => {
				data.push([item.cluster_name.replace(/\s+/g, '%20')])
			})
			break
		case 3:
			var totalGrossIncome = 0
			var totalNetIncome = 0
			csvData.income.map((item, i) => {
				totalNetIncome += item.net_income
				totalGrossIncome += item.gross_income
			})
			data.push(["INCOME"])
			data.push(["TOTAL",,,`Php%20${totalGrossIncome},Php%20${totalNetIncome}`])
			data.push(["DELIVERY%20DATE","CROP","SUPPLY%20DELIVERED","GROSS%20INCOME%20(PHP)",'NET%20INCOME%20(PHP)'])
			csvData.income.map((item, i) => {
				data.push([formatDate(item.delivery_date).replace(/\s+/g, '%20'),item.crop.replace(/\s+/g, '%20'),item.supply_delivered,item.gross_income,item.net_income])
			})
			break
		case 4:
			data.push(["FINANCIAL%20TRANSACTION"])
			data.push(["DATE%20OF%20RELEASE","DUE%20DATE","AMOUNT%20AVAILED%20(Php)","LOAD%20PROVIDER","LOAN%20SOURCE","LOAN%20TYPE","STATUS%20OF%20LOAN"])
			csvData.financialTransactions.map((item, i) => {
				data.push([formatDate(item.release_date).replace(/\s+/g, '%20'),formatDate(item.due_date).replace(/\s+/g, '%20'),item.amount_availed,item.loan_provider_name.replace(/\s+/g, '%20'),item.loan_source_name.replace(/\s+/g, '%20'),item.loan_type_name.replace(/\s+/g, '%20'),item.loan_status_name.replace(/\s+/g, '%20')])
			})
	}
	data.push([])
	data.push(['Date%20Generated: ', `${dateTime.toDateString()} ${dateTime.toLocaleTimeString()}`.replace(/\s+/g, '%20')])
	var csvRow = [];
	for(const v of data) {
		csvRow.push(v.join(","));
	}
	var csvString = csvRow.join("%0A");
	var a = document.createElement('a');
	a.href = 'data:attachment/csv,' + csvString;
	a.target = "_Blank";
	a.download = filename + ".csv";
	a.click();
}

export default ReportFarmerML
